import type {
  DiscountDTO,
  IngridCart,
  IngridCartItem,
  OldProductDTO,
  StorefrontOrderLine
} from 'ecosystem'
import { v4 as uuidv4 } from 'uuid'
import { sumArrayOfNumbers } from 'shared-utils'
import { orderLineValueCalculator } from '../../payment'
import { getProductImages } from '../../products'

const mapOrderLinesToIngridCartItems = (
  items: StorefrontOrderLine<OldProductDTO>[],
  cartDiscountCode: DiscountDTO | null
): IngridCartItem[] => {
  return items.map((item) => {
    const { product } = item
    const { unitPriceWithDiscount, unitPrice } = orderLineValueCalculator(item, cartDiscountCode)
    const { mainImageUrl } = getProductImages(product.medias)

    // When you need to test INGRID with Vinlagring credentials, comment out this line
    // const attributes = [`delivery_id:62f22c61a92edf5ce162d3a7`]
    const attributes = [`delivery_id:${product.deliveryId}`]
    const ingridAttr = product.specifications?.find((spec) => spec.name.toLowerCase() === 'ingrid')

    if (ingridAttr?.value) {
      attributes.push(ingridAttr?.value)
    }

    return {
      discount: unitPrice - unitPriceWithDiscount,
      name: product.name,
      price: unitPriceWithDiscount,
      quantity: item.quantity,
      sku: product.articleNumber,
      attributes,
      image_url: mainImageUrl
    }
  })
}

export const generateIngridCart = (
  items: StorefrontOrderLine<OldProductDTO>[],
  cartDiscountCode: DiscountDTO | null
): IngridCart => {
  const cartItems = mapOrderLinesToIngridCartItems(items, cartDiscountCode)

  return {
    cart_id: uuidv4(),
    items: cartItems,
    total_value: sumArrayOfNumbers(cartItems.map((item) => item.price * item.quantity)),
    total_discount: sumArrayOfNumbers(cartItems.map((item) => item.discount * item.quantity))
  }
}
